import { useState } from "react";

export default function ContactUs() {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    phone: "",
    issueType: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const GOOGLE_FORM_URL =
    "https://docs.google.com/forms/d/e/1FAIpQLSfdcuwM6DYEheNaz3ohxSopiOYJNVfj-6r5FQfSM9aL-3nWOg/formResponse";

  const ENTRY_IDS = {
    username: "entry.2005620554",
    email: "entry.1045781291",
    phone: "entry.1166974658",
    issueType: "entry.99155617",
    message: "entry.839337160",
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formBody = new FormData();
    formBody.append(ENTRY_IDS.username, formData.username);
    formBody.append(ENTRY_IDS.email, formData.email);
    formBody.append(ENTRY_IDS.phone, formData.phone);
    formBody.append(ENTRY_IDS.issueType, formData.issueType);
    formBody.append(ENTRY_IDS.message, formData.message);

    await fetch(GOOGLE_FORM_URL, {
      method: "POST",
      mode: "no-cors",
      body: formBody,
    });

    setSubmitted(true);
    setFormData({
      username: "",
      email: "",
      phone: "",
      issueType: "",
      message: "",
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 via-white to-purple-100 flex items-center justify-center p-4 sm:p-8">
      <div className="bg-white/90 backdrop-blur-md shadow-2xl rounded-3xl p-6 sm:p-10 w-full max-w-2xl transition-transform duration-500 hover:scale-[1.01]">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 drop-shadow-sm">
            Contact Support
          </h1>
          <p className="text-gray-600 mt-2 max-w-md mx-auto leading-relaxed">
            Need help or want to share feedback? Fill out this form and our team
            will respond shortly.
          </p>
        </div>

        {submitted ? (
          <div className="text-center py-10">
            <p className="text-green-600 text-2xl font-semibold mb-4">
              ✅ Thank you!
            </p>
            <p className="text-gray-700">
              Your message has been successfully submitted.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Username */}
            <div>
              <label className="block mb-2 text-gray-700 font-semibold">
                Username
              </label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
                placeholder="Enter your name"
                className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-400 focus:outline-none transition"
              />
            </div>

            {/* Email */}
            <div>
              <label className="block mb-2 text-gray-700 font-semibold">
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="you@example.com"
                className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-400 focus:outline-none transition"
              />
            </div>

            {/* Phone Number */}
            <div>
              <label className="block mb-2 text-gray-700 font-semibold">
                Phone Number
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                pattern="[0-9]{10}"
                placeholder="Enter 10-digit number"
                className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-400 focus:outline-none transition"
              />
            </div>

            {/* Issue Type */}
            <div>
              <label className="block mb-3 text-gray-700 font-semibold">
                Issue Type
              </label>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                {[
                  "Support",
                  "Feedback",
                  "Report",
                  "Advertise",
                  "DMCA",
                  "Partnership",
                  "Other",
                ].map((type) => (
                  <label
                    key={type}
                    className={`flex items-center justify-center border rounded-xl py-2 px-3 text-sm font-medium cursor-pointer transition 
                      ${
                        formData.issueType === type
                          ? "bg-blue-600 text-white border-blue-600"
                          : "hover:bg-blue-50 border-gray-300 text-gray-700"
                      }`}
                  >
                    <input
                      type="radio"
                      name="issueType"
                      value={type}
                      checked={formData.issueType === type}
                      onChange={handleChange}
                      className="hidden"
                    />
                    {type}
                  </label>
                ))}
              </div>
            </div>

            {/* Message */}
            <div>
              <label className="block mb-2 text-gray-700 font-semibold">
                Message
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="4"
                placeholder="Describe your issue or feedback..."
                className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-400 focus:outline-none transition resize-none"
              />
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full py-3 rounded-xl font-semibold text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 shadow-lg transition-transform transform hover:scale-[1.02] active:scale-[0.98]"
            >
              Submit
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
